import styled from "styled-components";
import { PeakDetailInfoProps } from "../../../constants/types";
import { COLORS } from "../../../constants/colors";

const PeakDetailInfo = (props: PeakDetailInfoProps) => {
  return (
    <Container>
      <Type>{props.type}</Type>
      <Value>
        {props.value.toLocaleString()}
        <span className="unit">kW</span>
      </Value>
    </Container>
  );
};

export default PeakDetailInfo;

const Container = styled.div`
  width: 30%;
  height: 18%;
  margin-top: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.8vw;
  font-weight: 500;
  color: ${COLORS.fontColor};
`;

const Type = styled.div`
  width: 100%;
  height: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Value = styled.div`
  width: 100%;
  height: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9vw;

  .unit {
    font-size: 0.6vw;
    padding: 5% 0 0 2%;
  }
`;
